export default __webpack_public_path__ + "images/pm-c5a64f87b2370f6a2ae3cf9d6523c9e4.svg";